import axios from 'axios'
import {
  setToken,
  getToken,
  removeToken
} from "@/assets/js/auth.js";
import baseUrl from '@/assets/js/baseUrl.js';

let autoLoginPromise = null;

/**
 * 等待 autoLogin 完成（供 request 拦截器使用）
 */
export const waitForAutoLogin = () => autoLoginPromise || Promise.resolve(true);

/**
 * 自动登录模块
 * @param {Object} store - Vuex store实例
 * @returns {Object} - 包含自动登录方法的对象
 */
export const useAutoLogin = (store) => {
  /**
   * 检查用户是否已登录
   * @returns {boolean} - 已登录返回true，未登录返回false
   */
  const checkLoggedIn = () => {
    const userToken = getToken("USER_Msg");
    return !!userToken;
  };

  const doAutoLogin = async () => {
    const params = new URLSearchParams(window.location.search);
    const activeCode = params.get('activeCode');

    if (activeCode) {
      removeToken('USER_Msg');
    } else if (checkLoggedIn()) {
      return true;
    }

    if (!activeCode) return false;

    try {
      const url = baseUrl.slice(0, baseUrl.length - 3);
      const response = await axios({
        url: `${url}/Three/Users/codeLogin`,
        method: "post",
        data: {
          code: activeCode
        },
        headers: {
          'content-Type': 'application/x-www-form-urlencoded'
        }
      });
      sessionStorage.removeItem('pcHasActiveCode')
      sessionStorage.removeItem('h5HasActiveCode')
      store.commit({
        type: 'changeUser',
        data: response.data
      });
      sessionStorage.setItem('activeCode', activeCode);
      setToken("USER_Msg", JSON.stringify(response.data));
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.delete('activeCode');
      window.history.replaceState({}, document.title, urlObj.toString());

      return true;
    } catch (error) {
      console.error('自动登录失败:', error);
      return false;
    }
  };

  const handleAutoLogin = async () => {
    if (!autoLoginPromise) {
      autoLoginPromise = doAutoLogin();
    }
    return autoLoginPromise;
  };

  return {
    handleAutoLogin,
    waitForAutoLogin
  };
};



// WEBPACK FOOTER //
// ./src/assets/js/autoLogin.js